import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Pipe({
  name: 'minutesSeconds'
})
export class MinutesSecondsPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      this.translate.instant('userLogin.twoFactorAuthentication.message1') +
      + ('00' + minutes).slice(-1) + this.translate.instant('userLogin.twoFactorAuthentication.message2') + ('00' + Math.floor(value - minutes * 60)).slice(-2)
      + this.translate.instant('userLogin.twoFactorAuthentication.message3') //' seconds before requesting a new authentication code'
    );
  }

}
